import { isNumber } from 'lodash';
import numbro from 'numbro';
import nl from 'numbro/languages/nl-NL';
import en from 'numbro/languages/en-GB';
import de from 'numbro/languages/de-DE';

numbro.registerLanguage(en);
numbro.registerLanguage(nl);
numbro.registerLanguage(de);

class NumberFormatter {
  static setLocale = (languageCode = 'en-GB') => {
    numbro.setLanguage(languageCode);
  };

  static formatSeparator = (number, unit = '', mantissa = 2) => {
    if (!isNumber(number)) {
      return '--';
    }
    const value = numbro(number).format({ thousandSeparated: true, mantissa });
    return `${value} ${unit || ''}`.trim();
  };

  static formatMeterToCentimeter = (number, unit, mantissa = 0) => {
    if (!isNumber(number)) {
      return '--';
    }
    const cmValue = number * 100;
    const value = numbro(cmValue).format({ mantissa, optionalMantissa: false });
    return `${value} ${unit || ''}`.trim();
  };

  static isValidNumber = (value) => {
    return isNumber(value) && Number.isFinite(value);
  };
}

export default NumberFormatter;
